import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ImproveDatasetResults} from '~components/models/finetune/improve-dataset/ImproveDatasetResults';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/finetune/improve-dataset')({
  component: ImproveDatasetPage,
});

function ImproveDatasetPage() {
  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout showBackButton customContentAndFooter>
        <ImproveDatasetResults />
      </BaseLayout>
    </ModelProvider>
  );
}
